import axios from "axios"; 
import { baseUrl, headers } from "./HelpService";
import { setPackingList } from "../../Redux/packingListSlice";
import { Dispatch } from "redux";
import { TPackingList } from "../../types/PackingList.type";

const PackingListUrl = baseUrl + 'packing_lists/';

const savePackingList = async (
    dispatch: Dispatch,
    account_id: string,
    name: string,
    logo: File | null,
    signature: string | null
): Promise<TPackingList | null> => {
    let formData = new FormData();
    formData.append("account_id", account_id);
    formData.append("name", name);

    if (logo) {
        formData.append("logo_url", logo, logo.name);
    }

    if (signature) {
        const signatureBlob = await (await fetch(signature)).blob();
        formData.append("signature_url", signatureBlob, 'signature.png');
    }

    try {
        const response = await fetch(PackingListUrl + 'save_packing_list/', {
            method: "POST",
            body: formData, 
            headers: headers() 
        });

        if (!response.ok) {
            throw new Error('Failed to save packing list');
        }

        const data: TPackingList = await response.json();
        dispatch(setPackingList(data));

        return data;
    } catch (error) {
        console.error('Error saving packing list:', error);
        return null;
    }
};

const getPackingList = async (account_id: string): Promise<TPackingList | null> => {
    try {
        const response = await axios.get(`${PackingListUrl}get_packing_list/?account_id=${account_id}`, {
            headers: headers(),
        });
        return response.data as TPackingList;
    } catch (error) {
        console.error('Error fetching packing list:', error);
        return null;
    }
};

export const fetchAndStorePackingList = (account_id: string) => async (dispatch: any) => {
    const data = await getPackingList(account_id);
    if (data) {
        dispatch(setPackingList(data));
    }
};

export const downloadSignature = async (signatureUrl: string): Promise<string | null> => {
    try {
        const response = await axios.get(`${PackingListUrl}download_signature/?signature_url=${encodeURIComponent(signatureUrl)}`, {
            headers: headers()
        });

        if (response.status !== 200) {
            throw new Error('Failed to download signature');
        }

        const data = response.data;

        if (data && data.base64_image && data.base64_image.startsWith('data:image/png;base64,')) {
            return data.base64_image;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error downloading signature:', error);
        return null;
    }
};

export const downloadLogo = async (logoUrl: string): Promise<string | null> => {
    try {
        const response = await axios.get(`${PackingListUrl}download_logo/?logo_url=${encodeURIComponent(logoUrl)}`, {
            headers: headers()
        });

        if (response.status !== 200) {
            throw new Error('Failed to download logo');
        }

        const data = response.data;

        if (data && data.base64_image && data.base64_image.startsWith('data:image/png;base64,')) {
            return data.base64_image;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error downloading logo:', error);
        return null;
    }
};

export default {
    savePackingList,
    getPackingList
};
